module.exports = __webpack_public_path__ + "static/popupsmart-dev-fa399a765b24d0666577c664ce7ef5f3.png";